import { evaluateCondition, evaluateRules, ruleMatches } from './rulesEngine';
import { pickWinner } from './pickWinner';
import { SYSTEM_RULES } from '../config/rateShopConstants';

/** Replay against recorded quotes only; groups omitted from the original quote cannot be recreated. */
export function previewRule(decision, draft, rules, settings) {
  const context = decision.context;
  const rule = { ...draft, id: draft.id || 'preview-rule' };
  const effectiveRules = rules.length ? rules : SYSTEM_RULES;
  const replayRules = [rule, ...effectiveRules.filter(r => r.id !== rule.id)];
  const { plan, trace } = evaluateRules(context, replayRules);
  const contextKey = { tag: 'tags', sku: 'skus', postalPrefix: 'postalCode' };
  const missingFields = [
    ...new Set(
      replayRules
        .flatMap(r => [...(r.match?.all || []), ...(r.match?.any || [])])
        .map(c => c.field)
        .filter(
          field =>
            !Object.prototype.hasOwnProperty.call(
              context,
              contextKey[field] || field
            )
        )
    )
  ];
  const conditions = ['all', 'any'].flatMap(group =>
    (rule.match?.[group] || []).map(condition => ({
      group,
      condition,
      matched: evaluateCondition(context, condition)
    }))
  );
  const rates = (decision.rates || []).filter(
    rate =>
      !plan.excludeGroups.has(rate.group) &&
      settings.groups?.[rate.group] !== false &&
      settings.carrierAccounts?.[rate.carrierId] !== false
  );
  const simulationMessage = ['applied', 'human-override', 'reverted'].includes(
    decision.status
  )
    ? 'This order would not change: it was already written or overridden. Re-rate it to apply this rule.'
    : !decision.rates?.length
    ? "No rates were recorded for this decision, so a winner can't be simulated; conditions are still evaluated."
    : null;
  const result = simulationMessage
    ? { winner: null, candidates: [], reason: null, notes: [] }
    : plan.skip
    ? { winner: null, candidates: [], reason: plan.skip.reason, notes: [] }
    : pickWinner({ rates }, plan, settings);
  return {
    ...result,
    simulationMessage,
    plan,
    trace,
    missingFields,
    conditions,
    matched: ruleMatches(context, rule)
  };
}

export const sameRate = (a, b) =>
  Boolean(
    a &&
      b &&
      a.carrierId === b.carrierId &&
      a.serviceCode === b.serviceCode &&
      a.packageType === b.packageType &&
      a.total === b.total
  );

export const validateSweep = sweep =>
  [
    ['lookbackHours', 'Lookback hours'],
    ['maxShipmentsPerRun', 'Max shipments per run']
  ]
    .filter(
      ([key]) =>
        !Number.isFinite(Number(sweep?.[key])) || !(Number(sweep?.[key]) > 0)
    )
    .map(([, label]) => `${label} must be greater than 0.`);
